enum AccessReportsAdminDashboardTabEnum {
  Products = "Products",
  CoverPage = "Cover Page",
  PrintSettings = " Print Settings",
}

export { AccessReportsAdminDashboardTabEnum };
